import BaseService from "./BaseService";

export default class PaisService extends BaseService {
  static getUrlBase = () => "/api/pais";
}